<template>
	<validation-observer #default="{ handleSubmit, valid }">
		<Modal
			width="1000px"
		>
			<template #modal-title>
				Manage Response Channels
			</template>
			<template #modal-title-action>
				<TextButton
					:disabled="!valid"
					@click="addResponseChannel"
				>
					<v-icon>
						mdi-plus
					</v-icon>
					Add Response Channel
				</TextButton>
			</template>
			<template #modal-content>
				<v-simple-table dense>
					<template #default>
						<thead>
							<tr>
								<th
									class="text-left"
									style="width: 28%;"
									scope="col"
								>
									Response Channel Name
								</th>
								<th
									class="text-left"
									style="width: 28%;"
									scope="col"
								>
									Response Channel Code
								</th>
								<th
									class="text-left"
									style="width: 22%;"
									scope="col"
								>
									{{ 'Brand' | useLabels }}
								</th>
								<th
									class="text-left"
									style="width: 22%;"
									scope="col"
								>
									Default?
								</th>
								<th
									class="text-center"
									style="width: 80px;"
									scope="col"
								>
									Action
								</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(responseChannel, index) in newResponseChannels"
								:key="index"
							>
								<td>
									<TextField
										v-model="responseChannel.responseChannelName"
										small
										label="Response channel name *"
										class="py-2"
										:rules="{required: true, max:100}"
									/>
								</td>
								<td>
									<TextField
										v-model="responseChannel.responseChannelCode"
										small
										label="Reponse channel code *"
										class="py-2"
										:rules="{required: true, max:10}"
									/>
								</td>
								<td>
									<Dropdown
										v-model="responseChannel.brandId"
										:items="brandOptions"
										custom-sort
										small
										class="py-2"
										rules="required"
										:label="'Brand*' | useLabels"
										searchable
									/>
								</td>
								<td>
									<v-switch
										:input-value="responseChannel.isDefault"
										label="Is Default"
										class="mt-0"
										inset
										dense
										hide-details
										:disabled="isDefaultDisabled(index) || responseChannel.brandId == null"
										@change="updateIsDefault(index, $event)"
									/>
								</td>
								<td style="text-align: center;">
									<v-menu offset-y>
										<template #activator="{ on, attrs }">
											<v-btn
												icon
												small
												v-bind="attrs"
												v-on="on"
												@click.stop
											>
												<v-icon>
													mdi-dots-horizontal
												</v-icon>
											</v-btn>
										</template>
										<v-list dense>
											<v-list-item @click="removeResponseChannel(index)">
												<v-list-item-content>
													<v-list-item-title>
														Remove
													</v-list-item-title>
												</v-list-item-content>
											</v-list-item>
										</v-list>
									</v-menu>
								</td>
							</tr>
						</tbody>
					</template>
				</v-simple-table>
			</template>
			<template #modal-footer>
				<v-spacer />
				<SecondaryActionButton @click="close">
					Cancel
				</SecondaryActionButton>
				<PrimaryActionButton @click="handleSubmit(submit)">
					Confirm
				</PrimaryActionButton>
			</template>
		</Modal>
	</validation-observer>
</template>

<script>
import TextButton from '../../../../../../shared/components/text-button.vue'
import Modal from '../../../../../../shared/components/modal.vue'
import SecondaryActionButton from '../../../../../../shared/components/secondary-action-button.vue'
import PrimaryActionButton from '../../../../../../shared/components/primary-action-button.vue'
import TextField from '../../../../../../shared/components/text-field.vue'
import Dropdown from '../../../../../../shared/components/dropdown.vue'
import { brandOptions } from '../../../../../../shared/state/brands.js'
export default {
	components: { Dropdown, TextField, PrimaryActionButton, SecondaryActionButton, Modal, TextButton },
	props: {
		responseChannels: {
			type: Array,
			default: () => []
		}
	},
	setup () {
		return {
			brandOptions
		}
	},
	data () {
		return {
			newResponseChannels: this.responseChannels
		}
	},
	methods: {
		close () {
			this.$emit('close')
		},
		removeResponseChannel (index) {
			this.$delete(this.newResponseChannels, index)
		},
		addResponseChannel () {
			this.newResponseChannels = [...this.newResponseChannels, {
				responseChannelName: null,
				responseChannelCode: null,
				brandId: null,
				isDefault: false
			}]
		},
		submit () {
			this.$emit('update:responseChannels', this.newResponseChannels)
			this.close()
		},
		isDefaultDisabled (index) {
			if (!this.newResponseChannels[index].isDefault === true) {
				if (this.newResponseChannels.find(channel =>
					channel.responseChannelId !== this.newResponseChannels[index].responseChannelId &&
					channel.brandId === this.newResponseChannels[index].brandId && channel.isDefault === true)) {
					return true
				}
			}
			return false
		},
		updateIsDefault (index, value) {
			this.newResponseChannels[index].isDefault = value
		}
	}
}
</script>
